export default __webpack_public_path__ + "static/media/hcis-project.035f7f68.png";